/**
 * Include your custom JavaScript here.
 *
 * JAT taxonomy filter cleanup:
 * - Hide legacy Product type.
 * - Hide filter values that do not narrow the current result set.
 * - Keep active values visible so customers can clear them.
 * - Hide a filter group when no useful values remain.
 */

(function () {
  'use strict';

  function parseCount(text) {
    if (!text) return null;

    var match = text.match(/\(([\d,\.\s]+)\)\s*$/);
    if (!match) return null;

    var digits = match[1].replace(/\D/g, '');
    return digits ? parseInt(digits, 10) : null;
  }

  function getCurrentResultCount(section) {
    var total = section.querySelector('.collection__products-count-total');
    if (total) {
      var totalText = total.textContent || '';
      var digits = totalText.replace(/\D/g, '');
      if (digits) return parseInt(digits, 10);
    }

    var data = section.querySelector('script[data-collection-products-count]');
    if (data) {
      try {
        var parsed = JSON.parse(data.textContent);
        var text = parsed.productsCount || '';
        var dataDigits = text.replace(/\D/g, '');
        if (dataDigits) return parseInt(dataDigits, 10);
      } catch (e) {
        // Fail open: keep filters visible if the count cannot be read.
      }
    }

    return null;
  }

  function getValueContainer(input) {
    return input.closest('.collection__filter-checkbox, .visual-filter, .color-swatch');
  }

  function getValueLabel(container) {
    if (!container) return null;
    return container.querySelector('label');
  }

  function tidyFilterGroup(group, currentCount) {
    var inputs = Array.prototype.slice.call(
      group.querySelectorAll('input[type="checkbox"][name^="filter."]')
    );

    if (inputs.length === 0) return;

    var isLegacyProductType = inputs.some(function (input) {
      return input.name === 'filter.p.product_type';
    });

    if (isLegacyProductType) {
      group.hidden = true;
      group.setAttribute('data-jat-hidden-filter', 'legacy-product-type');
      return;
    }

    var visibleValues = 0;

    inputs.forEach(function (input) {
      var container = getValueContainer(input);
      var label = getValueLabel(container);

      if (!container || !label) {
        visibleValues += 1;
        return;
      }

      // Active values must remain visible so the customer can uncheck them.
      if (input.checked) {
        container.hidden = false;
        container.removeAttribute('data-jat-hidden-value');
        visibleValues += 1;
        return;
      }

      var valueCount = parseCount(label.textContent || '');

      // If counts are unavailable, fail open rather than hiding a valid option.
      if (valueCount === null || currentCount === null) {
        container.hidden = false;
        container.removeAttribute('data-jat-hidden-value');
        visibleValues += 1;
        return;
      }

      // Zero-result values and values matching the entire current result set
      // cannot meaningfully narrow the collection.
      if (valueCount === 0 || valueCount === currentCount) {
        container.hidden = true;
        container.setAttribute('data-jat-hidden-value', 'non-narrowing');
      } else {
        container.hidden = false;
        container.removeAttribute('data-jat-hidden-value');
        visibleValues += 1;
      }
    });

    group.hidden = visibleValues === 0;

    if (visibleValues === 0) {
      group.setAttribute('data-jat-hidden-filter', 'no-useful-values');
    } else {
      group.removeAttribute('data-jat-hidden-filter');
    }
  }

  function tidyCollectionFilters() {
    document.querySelectorAll('section[data-section-type="collection"]').forEach(function (section) {
      var currentCount = getCurrentResultCount(section);

      section.querySelectorAll('.collection__filter-group').forEach(function (group) {
        tidyFilterGroup(group, currentCount);
      });
    });
  }

  var scheduled = false;

  function scheduleCleanup() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      tidyCollectionFilters();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanup);
  } else {
    scheduleCleanup();
  }

  // Warehouse refreshes collection/filter markup dynamically after filtering.
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (mutation) {
      return mutation.addedNodes && mutation.addedNodes.length > 0;
    });

    if (shouldRun) scheduleCleanup();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
